/**
 * Утилиты для работы с языковыми префиксами в URL
 */

/**
 * Получить текущий язык из URL
 * @param {string} pathname - Путь из location.pathname
 * @returns {string} Код языка ('en', 'ru', 'ja')
 */
export const getLanguageFromPath = (pathname) => {
  const validLanguages = ['en', 'ru', 'ja']
  const pathParts = pathname.split('/').filter(Boolean)
  const firstPart = pathParts[0]
  
  if (validLanguages.includes(firstPart)) {
    return firstPart
  }
  
  return 'en' // По умолчанию английский
}

/**
 * Получить путь без языкового префикса
 * @param {string} pathname - Путь из location.pathname
 * @returns {string} Путь без языкового префикса
 */
export const getPathWithoutLanguage = (pathname) => {
  const pathParts = pathname.split('/').filter(Boolean)
  const validLanguages = ['en', 'ru', 'ja']
  
  if (validLanguages.includes(pathParts[0])) {
    const pathWithoutLang = '/' + pathParts.slice(1).join('/')
    // Если путь был только языковый префикс (например, /en), возвращаем '/'
    return pathWithoutLang === '/' ? '/' : pathWithoutLang
  }
  
  // Если путь не начинается с языкового префикса, возвращаем его как есть
  return pathname || '/'
}

/**
 * Создать путь с языковым префиксом
 * @param {string} path - Путь без языкового префикса (например, '/about')
 * @param {string} lang - Код языка ('en', 'ru', 'ja')
 * @returns {string} Путь с языковым префиксом (например, '/ru/about')
 */
export const createLocalizedPath = (path, lang = 'en') => {
  // Убираем начальный слэш, если есть
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  
  // Если путь пустой, возвращаем только языковой префикс
  if (!cleanPath) {
    return `/${lang}`
  }
  
  return `/${lang}/${cleanPath}`
}

/**
 * Проверить, является ли путь валидным языковым префиксом
 * @param {string} pathname - Путь из location.pathname
 * @returns {boolean}
 */
export const isValidLanguagePath = (pathname) => {
  const validLanguages = ['en', 'ru', 'ja']
  const pathParts = pathname.split('/').filter(Boolean)
  return validLanguages.includes(pathParts[0])
}

